/*
 * @Description:: 请补充填写
 * @Version: 1.0
 * @Author: 小白
 * @Date: 2025-07-21 14:09:57
 * @LastEditors: 小白
 * @LastEditTime: 2025-09-04 15:09:10
 * @FilePath: \tmswebsite\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const HomePage = () => import('@/views/HomePage')
// const Production = () => import('@/views/Production')
const customerSupport = () => import('@/views/customerSupport')
const aboutUs = () => import('@/views/aboutUs')
const contentcenter = () => import('@/views/contentcenter')
const ReportList = () => import('@/components/report_list/index.vue')
const singlenumber = () => import('@/views/singlenumber.vue')
const NewsDetails = () => import('@/components/report_list/NewsDetails.vue')
const NewsDetailsTwo = () => import('@/components/report_list/NewsDetailsTwo.vue')
const NewsDetailsThree = () => import('@/components/report_list/NewsDetailsThree.vue')

const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path:'/home',
    component:HomePage,
    meta:{
      title:'首页'
    }
  },
  {
    path:'/singlenumber',
    component:singlenumber,
    meta:{
      title:'单号查询'
    }
  },
  {
    path:'/aboutUs',
    component:aboutUs,
     meta:{
      title:'关于我们'
    }
  },
  {
    path:'/customerSupport',
    component:customerSupport,
     meta:{
      title:'服务支持'
    }
  },
  
  {
    path:'/contentcenter',
    component:contentcenter,
    children:[
      {
        path:'1',
        component:ReportList
      },
      {
        path:'2',
        component:ReportList
      },

    ]
  },
  {
    path:'/news_detail/1',
    component:NewsDetails
  },
  {
    path:'/news_detail/2',
    component:NewsDetailsTwo
  },
  {
    path:'/production/1',
    component:NewsDetailsThree
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})
router.beforeEach((to, from, next) => {
  document.title = '北京鲲鹏顺达供应链管理有限公司-'+  to.meta.title
  next()
})
export default router